import React from "react";

import styles from "./TagsInput.module.css";

const TagsInput = ( { addTags, placeholder } ) =>
{

    return (
        <div className="tags-input">
            <input
                className={styles.root}
                type="text"
                onKeyUp={ (e) => addTags(e)}
                placeholder={placeholder}
            />
        </div>
    );
}

TagsInput.defaultProps = {};

export default TagsInput;